import * as io from "io-ts";

export const MeasuresChartType = io.keyof({
  value: null,
  std: null,
});

export type MeasuresChartType = io.TypeOf<typeof MeasuresChartType>;
